import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	color: ${CSSVars.gray900};
	max-width: 1420px;
	margin: 0 auto;

	display: flex;
	flex-wrap: wrap;
	gap: 50px;

	flex-direction: column;

	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	.features-heading {
		font-family: ${CSSVars.primaryFont};
		font-weight: 700;
		font-size: 30px;
		line-height: 1.15;
		letter-spacing: -0.02em;
		color: ${CSSVars.black};
		text-align: center;
		margin: 0 auto 20px;
		max-width: 820px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: 40px;
		}
		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			font-size: 48px;
			margin-bottom: 30px;
		}
	}

	.card {
		&:nth-child(even) {
			flex-direction: row-reverse;
		}
	}

	.benefits {
		display: grid;
		grid-template-columns: 1fr;
		gap: 30px;
		margin: 100px 0;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 50px 60px;
		}

		.card {
			text-align: center;
			max-width: 520px;
			margin: 0 auto;

			img {
				width: 40px;
				height: 40px;
				object-fit: contain;
				display: block;
				margin: 0 auto;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					width: 48px;
					height: 48px;
				}
			}

			h3 {
				font-weight: 600;
				font-size: ${CSSVars.fontSizeLG};
				margin: 20px 0 10px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					margin: 24px 0 12px;
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			p {
				font-size: ${CSSVars.fontSizeMD};
				font-weight: 300;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeLG};
				}
			}
		}
	}

	/* ============================================================
	   Slim layout — instagram-feed only. Compact 3-column gallery
	   instead of full-width alternating rows. Every image renders
	   at the same 16:10 aspect ratio with object-fit: cover, so
	   source assets that include decorative whitespace, parallax
	   stacks, or floating elements all crop to a uniform shape.
	   ============================================================ */
	&.slim {
		max-width: 1240px;
		padding: 70px 20px;
		display: block;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			padding: 90px 30px;
		}
		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 110px 40px;
		}

		.features-heading {
			margin: 0 auto 40px;
			padding: 0;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				margin-bottom: 56px;
			}
		}

		/* 3-column responsive feature gallery */
		.feature-grid {
			list-style: none;
			margin: 0;
			padding: 0;
			display: grid;
			grid-template-columns: 1fr;
			gap: 20px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				grid-template-columns: repeat(2, 1fr);
				gap: 24px;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				grid-template-columns: repeat(3, 1fr);
				gap: 28px;
			}
		}

		.feature-card {
			background: ${CSSVars.white};
			border: 1px solid ${CSSVars.gray100};
			border-radius: 18px;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			position: relative;
			transition: transform 0.25s ease, box-shadow 0.25s ease,
				border-color 0.25s ease;

			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 3px;
				background: linear-gradient(
					270deg,
					${CSSVars.pink300} 0%,
					${CSSVars.purple500} 50%,
					${CSSVars.blue500} 100%
				);
				opacity: 0;
				transition: opacity 0.25s ease;
				z-index: 2;
			}

			&:hover {
				transform: translateY(-4px);
				box-shadow: 0 18px 40px rgba(16, 24, 40, 0.1);
				border-color: ${CSSVars.gray200};

				&::before {
					opacity: 1;
				}

				.img-wrap img {
					transform: scale(1.04);
				}
			}

			.img-wrap {
				width: 100%;
				aspect-ratio: 16 / 10;
				overflow: hidden;
				background: linear-gradient(
					135deg,
					rgba(245, 138, 138, 0.07) 0%,
					rgba(166, 108, 217, 0.05) 50%,
					rgba(91, 91, 255, 0.07) 100%
				);
				position: relative;

				img {
					width: 100% !important;
					height: 100% !important;
					object-fit: cover !important;
					object-position: center;
					transition: transform 0.5s ease;
				}
			}

			.card-body {
				padding: 22px;
				display: flex;
				flex-direction: column;
				gap: 8px;
				flex: 1;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					padding: 24px 22px 26px;
				}

				h3 {
					font-family: ${CSSVars.primaryFont};
					font-weight: 600;
					font-size: 18px;
					line-height: 1.3;
					letter-spacing: -0.01em;
					color: ${CSSVars.black};
					margin: 0;

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: 19px;
					}
				}

				p {
					font-family: ${CSSVars.secondaryFont};
					font-weight: 400;
					font-size: 14px;
					line-height: 1.6;
					color: #4b5563;
					margin: 0;
					/* No line clamp. This grid used to cap descriptions at 3
					   lines to keep card heights even, but 12 of 13 cards on
					   contact-form (and 51 of 55 across a 10-hub sample) hit
					   the cap, so visitors saw a trailing "..." on almost every
					   card and could not read the rest. The sibling
					   "What you get with..." grid on the same hub never clamped,
					   so the two card grids also disagreed, against the
					   grid-symmetry convention. The full text was always
					   server-rendered, so this changes what visitors can READ,
					   not what crawlers index. Cards still stretch to equal
					   height per row via the grid. The copy itself lives in the
					   apps collection, so shortening it would be a content
					   change, not a CSS one. */

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: 15px;
					}
				}
			}
		}

		/* "Also included in the editor" heading — sized to match the
		   "What you get with..." (WhyUseWidget branded) h2 so the two
		   2x2 card sections feel like equal-weight siblings rather than
		   parent / child. Per grid-symmetry rule in
		   ~/.claude/projects/-Users-sergei/memory/feedback_grid_symmetry.md
		   any two card grids on the same hub should match in heading
		   prominence, not just in card styling. */
		.extras-heading {
			font-family: ${CSSVars.primaryFont};
			font-weight: 700;
			font-size: 30px;
			line-height: 1.15;
			letter-spacing: -0.02em;
			color: ${CSSVars.black};
			text-align: center;
			margin: 80px auto 48px;
			padding: 0;
			max-width: 820px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: 40px;
				margin: 100px auto 56px;
			}
			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: 48px;
				margin: 120px auto 64px;
			}
		}

		/* Box features in the "Also included" sub-grid — pill icon
		   + gradient hover, matching InstagramFeedBenefits style.
		   No inner max-width: the grid spans the full .slim container
		   (1240px) so the 2 cards sit at the same width and gap as the
		   "What you get with..." (WhyUseWidget branded) cards above.
		   Per [[feedback_grid_symmetry]] — heading parity AND box-size
		   parity are both part of the symmetry rule. */
		& > .benefits {
			margin: 0;
			padding: 0;
			grid-template-columns: 1fr;
			gap: 18px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				grid-template-columns: repeat(2, 1fr);
				gap: 24px;
			}

			.card {
				background: ${CSSVars.white};
				border: 1px solid ${CSSVars.gray100};
				border-radius: 18px;
				padding: 28px;
				text-align: left;
				max-width: none;
				margin: 0;
				display: flex;
				flex-direction: column;
				gap: 14px;
				position: relative;
				overflow: hidden;
				transition: box-shadow 0.25s ease, transform 0.25s ease,
					border-color 0.25s ease;

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					padding: 36px 32px;
				}

				&::before {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					height: 3px;
					background: linear-gradient(
						270deg,
						${CSSVars.pink300} 0%,
						${CSSVars.purple500} 50%,
						${CSSVars.blue500} 100%
					);
					opacity: 0;
					transition: opacity 0.25s ease;
				}

				&:hover {
					transform: translateY(-3px);
					box-shadow: 0 16px 36px rgba(16, 24, 40, 0.08);
					border-color: ${CSSVars.gray200};

					&::before {
						opacity: 1;
					}

					.icon-wrap {
						background: linear-gradient(
							135deg,
							${CSSVars.blue500} 0%,
							${CSSVars.purple500} 50%,
							${CSSVars.pink300} 100%
						);
						border-color: transparent;
						color: ${CSSVars.white};

						img {
							filter: brightness(0) invert(1);
						}
					}
				}

				.icon-wrap {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 56px;
					height: 56px;
					border-radius: 14px;
					background: ${CSSVars.gray50};
					border: 1px solid ${CSSVars.gray100};
					color: ${CSSVars.blue500};
					transition: background 0.25s ease, border-color 0.25s ease,
						color 0.25s ease;
					flex-shrink: 0;
					margin: 0;

					svg {
						width: 28px;
						height: 28px;
					}

					img {
						width: 28px;
						height: 28px;
						margin: 0;
						transition: filter 0.25s ease;
					}
				}

				h3 {
					font-family: ${CSSVars.primaryFont};
					font-weight: 600;
					font-size: 19px;
					line-height: 1.3;
					letter-spacing: -0.01em;
					color: ${CSSVars.black};
					margin: 0;

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: 21px;
					}
				}

				p {
					font-family: ${CSSVars.secondaryFont};
					font-weight: 400;
					font-size: 15px;
					line-height: 1.65;
					color: #4b5563;
					margin: 0;
				}
			}
		}
	}
`;
